//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DataBlockClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetDataBlockQueryParameters = {
  patientId?: number | null | undefined ;
  caseId?: number | null | undefined ;
  visitId?: number | null | undefined ;
  visitIds?: number[] | null | undefined ;
  caseIds?: number[] | null | undefined ;
  variant?: Types.DataBlockVariant | null | undefined ;
  typeId?: number | null | undefined ;
  importIds?: string[] | null | undefined ;
  values?: { [key: string]: string[]; } | null | undefined ;
  begin?: Date | null | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type GetReimportResultDataBlockQueryParameters = {
  processId: string ;
}

export type GetWithValuesDataBlockQueryParameters = {
  patientId?: number | null | undefined ;
  caseId?: number | null | undefined ;
  visitId?: number | null | undefined ;
  visitIds?: number[] | null | undefined ;
  caseIds?: number[] | null | undefined ;
  variant?: Types.DataBlockVariant | null | undefined ;
  typeId?: number | null | undefined ;
  importIds?: string[] | null | undefined ;
  values?: { [key: string]: string[]; } | null | undefined ;
  begin?: Date | null | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type GetDataBlockDataBlockQueryParameters = {
  id: number ;
}

export type EditDataBlockQueryParameters = {
  id: number ;
}

export type RemoveDataBlockQueryParameters = {
  id: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'DataBlockClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockWithValuesDto, unknown, Types.CreateDataBlockDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockWithValuesDto, unknown, Types.CreateDataBlockDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateDataBlockDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getUrl(patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/data-blocks?";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (caseId !== undefined && caseId !== null)
    url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
if (visitId !== undefined && visitId !== null)
    url_ += "VisitId=" + encodeURIComponent("" + visitId) + "&";
if (visitIds !== undefined && visitIds !== null)
    visitIds && visitIds.forEach(item => { url_ += "VisitIds=" + encodeURIComponent("" + item) + "&"; });
if (caseIds !== undefined && caseIds !== null)
    caseIds && caseIds.forEach(item => { url_ += "CaseIds=" + encodeURIComponent("" + item) + "&"; });
if (variant !== undefined && variant !== null)
    url_ += "Variant=" + encodeURIComponent("" + variant) + "&";
if (typeId !== undefined && typeId !== null)
    url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
if (importIds !== undefined && importIds !== null)
    importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
if (values !== undefined && values !== null)
    values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
if (begin !== undefined && begin !== null)
    url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockDto, unknown, Types.PageableListDtoOfDataBlockDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfDataBlockDto, unknown, Types.PageableListDtoOfDataBlockDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetDataBlockQueryParameters): QueryKey;
export function getQueryKey(patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetDataBlockQueryParameters;

    return trimArrayEnd([
        'DataBlockClient',
        'get',
        patientId as any,
        caseId as any,
        visitId as any,
        visitIds as any,
        caseIds as any,
        variant as any,
        typeId as any,
        importIds as any,
        values as any,
        begin as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number[] | null | undefined,       context.queryKey[6] as number[] | null | undefined,       context.queryKey[7] as Types.DataBlockVariant | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as string[] | null | undefined,       context.queryKey[10] as { [key: string]: string[]; } | null | undefined,       context.queryKey[11] as Date | null | undefined,       context.queryKey[12] as number | undefined,       context.queryKey[13] as number | undefined,       context.queryKey[14] as string | null | undefined,       context.queryKey[15] as Types.SortDirection | undefined,       context.queryKey[16] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.PageableListDtoOfDataBlockDto, TError = unknown>(dto: GetDataBlockQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns DataBlocks WITHOUT `Values` included (so that response is shorter).
If you want `Values`, please use GetWithValues.
You could filter by `Values` like that:
- /api/data-blocks?values[AHI]=17
- /api/data-blocks?values[AHI__gt]=10 (greater than)
- /api/data-blocks?values[AHI__lt]=20 (less than)
- /api/data-blocks?values[AHI__ge]=17 (greater or equal)
- /api/data-blocks?values[AHI__le]=17 (less or equal)
- /api/data-blocks?values[comment__in]=substring (comment value includes 'substring')
- /api/data-blocks?values[AHI]=20&values[AHI]=21 (AHI is 20 or 21)
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param visitId (optional) 
 * @param visitIds (optional) 
 * @param caseIds (optional) 
 * @param variant (optional) 
 * @param typeId (optional) 
 * @param importIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param begin (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetQuery<TSelectData = Types.PageableListDtoOfDataBlockDto, TError = unknown>(patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.PageableListDtoOfDataBlockDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfDataBlockDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let patientId: any = undefined;
  let caseId: any = undefined;
  let visitId: any = undefined;
  let visitIds: any = undefined;
  let caseIds: any = undefined;
  let variant: any = undefined;
  let typeId: any = undefined;
  let importIds: any = undefined;
  let values: any = undefined;
  let begin: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetDataBlockQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfDataBlockDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns DataBlocks WITHOUT `Values` included (so that response is shorter).
If you want `Values`, please use GetWithValues.
You could filter by `Values` like that:
- /api/data-blocks?values[AHI]=17
- /api/data-blocks?values[AHI__gt]=10 (greater than)
- /api/data-blocks?values[AHI__lt]=20 (less than)
- /api/data-blocks?values[AHI__ge]=17 (greater or equal)
- /api/data-blocks?values[AHI__le]=17 (less or equal)
- /api/data-blocks?values[comment__in]=substring (comment value includes 'substring')
- /api/data-blocks?values[AHI]=20&values[AHI]=21 (AHI is 20 or 21)
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param visitId (optional) 
 * @param visitIds (optional) 
 * @param caseIds (optional) 
 * @param variant (optional) 
 * @param typeId (optional) 
 * @param importIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param begin (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfDataBlockDto | undefined) => Types.PageableListDtoOfDataBlockDto, patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getQueryKey(patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Returns DataBlocks WITHOUT `Values` included (so that response is shorter).
If you want `Values`, please use GetWithValues.
You could filter by `Values` like that:
- /api/data-blocks?values[AHI]=17
- /api/data-blocks?values[AHI__gt]=10 (greater than)
- /api/data-blocks?values[AHI__lt]=20 (less than)
- /api/data-blocks?values[AHI__ge]=17 (greater or equal)
- /api/data-blocks?values[AHI__le]=17 (less or equal)
- /api/data-blocks?values[comment__in]=substring (comment value includes 'substring')
- /api/data-blocks?values[AHI]=20&values[AHI]=21 (AHI is 20 or 21)
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param visitId (optional) 
 * @param visitIds (optional) 
 * @param caseIds (optional) 
 * @param variant (optional) 
 * @param typeId (optional) 
 * @param importIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param begin (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfDataBlockDto | undefined) => Types.PageableListDtoOfDataBlockDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function importUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/device-measurements";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function importMutationKey(): MutationKey {
  return trimArrayEnd([
      'DataBlockClient',
      'import',
    ]);
}

export function useImportMutation<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockWithValuesDto, unknown, Types.CreateDataBlockDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockWithValuesDto, unknown, Types.CreateDataBlockDto, TContext> {
  const key = importMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateDataBlockDto) => Client.import_(dto),
    mutationKey: key,
  });
}
  
export function startReimportUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/device-measurements/reimport";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function startReimportMutationKey(): MutationKey {
  return trimArrayEnd([
      'DataBlockClient',
      'startReimport',
    ]);
}

export function useStartReimportMutation<TContext>(options?: Omit<UseMutationOptions<string, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, void, TContext> {
  const key = startReimportMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.startReimport(),
    mutationKey: key,
  });
}
  
export function getReimportResultUrl(processId: string): string {
  let url_ = getBaseUrl() + "/api/data-blocks/device-measurements/reimport/{processId}";
if (processId === undefined || processId === null)
  throw new Error("The parameter 'processId' must be defined.");
url_ = url_.replace("{processId}", encodeURIComponent("" + processId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getReimportResultDefaultOptions: Omit<UseQueryOptions<Types.ReimportResultDto, unknown, Types.ReimportResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ReimportResultDto, unknown, Types.ReimportResultDto>, 'queryFn'>> = {
};
export function getGetReimportResultDefaultOptions() {
  return getReimportResultDefaultOptions;
};
export function setGetReimportResultDefaultOptions(options: typeof getReimportResultDefaultOptions) {
  getReimportResultDefaultOptions = options;
}

export function getReimportResultQueryKey(processId: string): QueryKey;
export function getReimportResultQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { processId,  } = params[0] as GetReimportResultDataBlockQueryParameters;

    return trimArrayEnd([
        'DataBlockClient',
        'getReimportResult',
        processId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockClient',
        'getReimportResult',
        ...params
      ]);
  }
}
export function __getReimportResult(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getReimportResult(
      context.queryKey[2] as string,axiosConfig    );
}

export function useGetReimportResultQuery<TSelectData = Types.ReimportResultDto, TError = unknown>(dto: GetReimportResultDataBlockQueryParameters, options?: Omit<UseQueryOptions<Types.ReimportResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetReimportResultQuery<TSelectData = Types.ReimportResultDto, TError = unknown>(processId: string, options?: Omit<UseQueryOptions<Types.ReimportResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetReimportResultQuery<TSelectData = Types.ReimportResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ReimportResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let processId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ processId,  } = params[0] as GetReimportResultDataBlockQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [processId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ReimportResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getReimportResult(context, axiosConfig) : __getReimportResult,
    queryKey: getReimportResultQueryKey(processId),
    ...getReimportResultDefaultOptions as unknown as Omit<UseQueryOptions<Types.ReimportResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetReimportResultData(queryClient: QueryClient, updater: (data: Types.ReimportResultDto | undefined) => Types.ReimportResultDto, processId: string) {
  queryClient.setQueryData(getReimportResultQueryKey(processId),
    updater
  );
}

export function setGetReimportResultDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ReimportResultDto | undefined) => Types.ReimportResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getWithValuesUrl(patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/data-blocks/with-values?";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (caseId !== undefined && caseId !== null)
    url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
if (visitId !== undefined && visitId !== null)
    url_ += "VisitId=" + encodeURIComponent("" + visitId) + "&";
if (visitIds !== undefined && visitIds !== null)
    visitIds && visitIds.forEach(item => { url_ += "VisitIds=" + encodeURIComponent("" + item) + "&"; });
if (caseIds !== undefined && caseIds !== null)
    caseIds && caseIds.forEach(item => { url_ += "CaseIds=" + encodeURIComponent("" + item) + "&"; });
if (variant !== undefined && variant !== null)
    url_ += "Variant=" + encodeURIComponent("" + variant) + "&";
if (typeId !== undefined && typeId !== null)
    url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
if (importIds !== undefined && importIds !== null)
    importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
if (values !== undefined && values !== null)
    values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
if (begin !== undefined && begin !== null)
    url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getWithValuesDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockWithValuesDto, unknown, Types.PageableListDtoOfDataBlockWithValuesDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfDataBlockWithValuesDto, unknown, Types.PageableListDtoOfDataBlockWithValuesDto>, 'queryFn'>> = {
};
export function getGetWithValuesDefaultOptions() {
  return getWithValuesDefaultOptions;
};
export function setGetWithValuesDefaultOptions(options: typeof getWithValuesDefaultOptions) {
  getWithValuesDefaultOptions = options;
}

export function getWithValuesQueryKey(dto: GetWithValuesDataBlockQueryParameters): QueryKey;
export function getWithValuesQueryKey(patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getWithValuesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetWithValuesDataBlockQueryParameters;

    return trimArrayEnd([
        'DataBlockClient',
        'getWithValues',
        patientId as any,
        caseId as any,
        visitId as any,
        visitIds as any,
        caseIds as any,
        variant as any,
        typeId as any,
        importIds as any,
        values as any,
        begin as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockClient',
        'getWithValues',
        ...params
      ]);
  }
}
export function __getWithValues(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getWithValues(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number[] | null | undefined,       context.queryKey[6] as number[] | null | undefined,       context.queryKey[7] as Types.DataBlockVariant | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as string[] | null | undefined,       context.queryKey[10] as { [key: string]: string[]; } | null | undefined,       context.queryKey[11] as Date | null | undefined,       context.queryKey[12] as number | undefined,       context.queryKey[13] as number | undefined,       context.queryKey[14] as string | null | undefined,       context.queryKey[15] as Types.SortDirection | undefined,       context.queryKey[16] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetWithValuesQuery<TSelectData = Types.PageableListDtoOfDataBlockWithValuesDto, TError = unknown>(dto: GetWithValuesDataBlockQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockWithValuesDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns DataBlocks with `Values` included
You could filter by `Values` like that:
/api/data-blocks?values[AHI]=17
/api/data-blocks?values[AHI__gt]=10 (greater than)
/api/data-blocks?values[AHI__lt]=20 (less than)
/api/data-blocks?values[AHI__ge]=17 (greater or equal)
/api/data-blocks?values[AHI__le]=17 (less or equal)
/api/data-blocks?values[comment__in]=substring (comment value includes 'substring')
/api/data-blocks?values[AHI]=20&values[AHI]=21 (AHI is 20 or 21)
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param visitId (optional) 
 * @param visitIds (optional) 
 * @param caseIds (optional) 
 * @param variant (optional) 
 * @param typeId (optional) 
 * @param importIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param begin (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetWithValuesQuery<TSelectData = Types.PageableListDtoOfDataBlockWithValuesDto, TError = unknown>(patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockWithValuesDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetWithValuesQuery<TSelectData = Types.PageableListDtoOfDataBlockWithValuesDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfDataBlockWithValuesDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let patientId: any = undefined;
  let caseId: any = undefined;
  let visitId: any = undefined;
  let visitIds: any = undefined;
  let caseIds: any = undefined;
  let variant: any = undefined;
  let typeId: any = undefined;
  let importIds: any = undefined;
  let values: any = undefined;
  let begin: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetWithValuesDataBlockQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfDataBlockWithValuesDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getWithValues(context, axiosConfig) : __getWithValues,
    queryKey: getWithValuesQueryKey(patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getWithValuesDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfDataBlockWithValuesDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns DataBlocks with `Values` included
You could filter by `Values` like that:
/api/data-blocks?values[AHI]=17
/api/data-blocks?values[AHI__gt]=10 (greater than)
/api/data-blocks?values[AHI__lt]=20 (less than)
/api/data-blocks?values[AHI__ge]=17 (greater or equal)
/api/data-blocks?values[AHI__le]=17 (less or equal)
/api/data-blocks?values[comment__in]=substring (comment value includes 'substring')
/api/data-blocks?values[AHI]=20&values[AHI]=21 (AHI is 20 or 21)
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param visitId (optional) 
 * @param visitIds (optional) 
 * @param caseIds (optional) 
 * @param variant (optional) 
 * @param typeId (optional) 
 * @param importIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param begin (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetWithValuesData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfDataBlockWithValuesDto | undefined) => Types.PageableListDtoOfDataBlockWithValuesDto, patientId?: number | null | undefined, caseId?: number | null | undefined, visitId?: number | null | undefined, visitIds?: number[] | null | undefined, caseIds?: number[] | null | undefined, variant?: Types.DataBlockVariant | null | undefined, typeId?: number | null | undefined, importIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, begin?: Date | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getWithValuesQueryKey(patientId, caseId, visitId, visitIds, caseIds, variant, typeId, importIds, values, begin, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Returns DataBlocks with `Values` included
You could filter by `Values` like that:
/api/data-blocks?values[AHI]=17
/api/data-blocks?values[AHI__gt]=10 (greater than)
/api/data-blocks?values[AHI__lt]=20 (less than)
/api/data-blocks?values[AHI__ge]=17 (greater or equal)
/api/data-blocks?values[AHI__le]=17 (less or equal)
/api/data-blocks?values[comment__in]=substring (comment value includes 'substring')
/api/data-blocks?values[AHI]=20&values[AHI]=21 (AHI is 20 or 21)
 * @param patientId (optional) 
 * @param caseId (optional) 
 * @param visitId (optional) 
 * @param visitIds (optional) 
 * @param caseIds (optional) 
 * @param variant (optional) 
 * @param typeId (optional) 
 * @param importIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param begin (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetWithValuesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfDataBlockWithValuesDto | undefined) => Types.PageableListDtoOfDataBlockWithValuesDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getDataBlockUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDataBlockDefaultOptions: Omit<UseQueryOptions<Types.DataBlockWithValuesDto, unknown, Types.DataBlockWithValuesDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DataBlockWithValuesDto, unknown, Types.DataBlockWithValuesDto>, 'queryFn'>> = {
};
export function getGetDataBlockDefaultOptions() {
  return getDataBlockDefaultOptions;
};
export function setGetDataBlockDefaultOptions(options: typeof getDataBlockDefaultOptions) {
  getDataBlockDefaultOptions = options;
}

export function getDataBlockQueryKey(id: number): QueryKey;
export function getDataBlockQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetDataBlockDataBlockQueryParameters;

    return trimArrayEnd([
        'DataBlockClient',
        'getDataBlock',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockClient',
        'getDataBlock',
        ...params
      ]);
  }
}
export function __getDataBlock(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDataBlock(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetDataBlockQuery<TSelectData = Types.DataBlockWithValuesDto, TError = unknown>(dto: GetDataBlockDataBlockQueryParameters, options?: Omit<UseQueryOptions<Types.DataBlockWithValuesDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetDataBlockQuery<TSelectData = Types.DataBlockWithValuesDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.DataBlockWithValuesDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDataBlockQuery<TSelectData = Types.DataBlockWithValuesDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DataBlockWithValuesDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetDataBlockDataBlockQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DataBlockWithValuesDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDataBlock(context, axiosConfig) : __getDataBlock,
    queryKey: getDataBlockQueryKey(id),
    ...getDataBlockDefaultOptions as unknown as Omit<UseQueryOptions<Types.DataBlockWithValuesDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetDataBlockData(queryClient: QueryClient, updater: (data: Types.DataBlockWithValuesDto | undefined) => Types.DataBlockWithValuesDto, id: number) {
  queryClient.setQueryData(getDataBlockQueryKey(id),
    updater
  );
}

export function setGetDataBlockDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DataBlockWithValuesDto | undefined) => Types.DataBlockWithValuesDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockClient',
      'edit',
      id as any,
    ]);
}

export function useEditMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DataBlockWithValuesDto, unknown, Types.UpdateDataBlockDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockWithValuesDto, unknown, Types.UpdateDataBlockDto, TContext> {
  const key = editMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateDataBlockDto) => Client.edit(id, dto),
    mutationKey: key,
  });
}
  
type Edit__MutationParameters = EditDataBlockQueryParameters & {
  dto: Types.UpdateDataBlockDto;
}

export function useEditMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockWithValuesDto, unknown, Edit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditDataBlockQueryParameters}): UseMutationResult<Types.DataBlockWithValuesDto, unknown, Edit__MutationParameters, TContext> {
  const key = editMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Edit__MutationParameters) => Client.edit(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockClient',
      'remove',
      id as any,
    ]);
}

export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.RemoveDataBlockDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.RemoveDataBlockDto, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.RemoveDataBlockDto) => Client.remove(id, dto),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveDataBlockQueryParameters & {
  dto: Types.RemoveDataBlockDto;
}

export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveDataBlockQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}